export default {
  en: {
    categories: {
      articles: 'Articles',
      news: 'News',
      contest: 'Contest',
      contests: 'Contests',
      review: 'Review',
      reviews: 'Reviews',
      'taste-test': 'Taste Test',
      album: 'Album',
      feature: 'Feature',
      features: 'Features',
      'cover-story': 'Cover Story',
      interview: 'Interview',
      gallery: 'Gallery',
      guide: 'Guide',
      guides: 'Guides',
      premiere: 'Premiere',
      listen: 'Listen',
      essentials: 'Essentials',
      'bandwagon-mix': 'Bandwagon Mix',
      gear: 'Gear',
      events: 'Events',
      gigs: 'Gigs',
      festivals: 'Festivals',
      music: 'Music',
      'recent-record-reviews': 'Recent Record Reviews',
      'artist-x-artist': 'Artist x Artist',
      video: 'Video',
      videos: 'Videos',
    },
    headers: {
      'watch-now': 'Watch Now',
      shop: 'Shop',
      discover: 'Discover Artists',
      'browse-all': 'Browse all',
      'top-features': 'Top Features',
      browse: 'Browse Collections',
      'happening-this-month': 'happening this month',
    },
    buttons: {
      'read-article': 'Read Article',
      'buy-now': 'Buy Now',
      'watch-now': 'Watch Now',
      'view-all': 'or View All Items',
      'view-all-gigs': 'View all gigs',
      'view-more-reviews': 'View More Reviews',
      'view-more-guides': 'View More Guides',
      'read-full-guide': 'Read Full Guide',
      'view-more-videos': 'View More Videos',
    },
    descriptions: {
      shop: 'Get the coolest merchandise of your favorite artists and bands.',
      like: 'Like what you read? Show our writer some love!',
    },
    videos: {
      views: 'views'
    },
  },
  cn: {
    categories: {
      articles: '文章',
      news: '新闻',
      contest: '活动',
      contests: '活动',
      review: '乐评',
      reviews: '乐评',
      album: '专辑',
      feature: '特写',
      features: '特写',
      'cover-story': '封面故事',
      interview: '专访',
      gallery: '现场抓拍',
      guide: '指南',
      guides: '指南',
      premiere: '初登场',
      listen: '聆听',
      essentials: '非听不可',
      'bandwagon-mix': '伴乐跟特调',
      gear: '乐器周边',
      events: '音乐盛典',
      gigs: '现场演出',
      festivals: '音乐节',
      music: '纯音乐',
      'recent-record-reviews': '乐评',
      'artist-x-artist': '艺人 x 艺人',
      video: '视频',
      videos: '视频',
    },
    headers: {
      'watch-now': '立刻观看',
      shop: '商店',
      discover: '发现本地歌手',
      'happening-this-month': '本月的演出',
      browse: '',
      'top-features': '',
      'browse-all': '所有',
    },
    buttons: {
      'read-article': '阅读文章',
      'buy-now': '购买',
      'watch-now': '立即观看',
      'view-all': '游览更多',
      'view-all-gigs': '游览所有演出',
      'view-more-reviews': '游览更多乐评',
      'view-more-guides': '游览更多指南文章',
      'read-full-guide': '阅读整篇',
      'view-more-video': '游览更多',
    },
    descriptions: {
      shop: '收集您最爱的歌手的最酷商品。',
      like: 'Like what you read? Show our writer some love!',
    },
    videos: {
      views: '次观看'
    },
  },
};
